const isReactNativeWebView = () => /reactnative/i.test(navigator.userAgent);

function uint8ArrayToBase64(bytes) {
  if (typeof Buffer !== "undefined" && Buffer.isBuffer?.(bytes)) {
    return Buffer.from(bytes).toString("base64");
  }
  const u8 = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let binary = "";
  for (let i = 0; i < u8.byteLength; i++) {
    binary += String.fromCharCode(u8[i]);
  }
  return btoa(binary);
}

const sendBluetoothCommand = (type, payload = {}) => {
  if (!isReactNativeWebView()) {
    console.warn("Not in React Native WebView environment");
    return Promise.resolve(false);
  }

  const message = {
    id: Date.now().toString(),
    type,
    payload,
  };

  window.ReactNativeWebView.postMessage(JSON.stringify(message));
  return Promise.resolve(true);
};

/** Legacy XML pipeline for native apps that render Printout markup. */
const printViaBluetooth = (content, config = {}) => {
  const defaultConfig = {
    beep: true,
    cut: true,
    tailingLine: true,
    encoding: "UTF-8",
    codepage: 0,
  };

  const printMsg = `<Printout>${content}</Printout>`;

  return sendBluetoothCommand("print", {
    printText: printMsg,
    options: { ...defaultConfig, ...config },
  });
};

/**
 * Raw ESC/POS bytes for native handlers that accept base64 (field name kept stable for app updates).
 */
const printEscPosBase64ViaReactNative = (escPosBytes, config = {}) => {
  const defaultConfig = {
    beep: true,
    cut: true,
    tailingLine: true,
    encoding: "UTF-8",
    codepage: 0,
    format: "escpos",
  };

  const base64 = uint8ArrayToBase64(escPosBytes);

  return sendBluetoothCommand("print", {
    printBase64: base64,
    options: { ...defaultConfig, ...config },
  });
};

export {
  isReactNativeWebView,
  sendBluetoothCommand,
  printViaBluetooth,
  printEscPosBase64ViaReactNative,
  uint8ArrayToBase64,
};
